const firestore = {
  firestorePath: '/reminders',
  firestoreRefType: 'collection',
  moduleName: 'reminders',
  statePropName: 'reminders',
  namespaced: true,
  serverChange: {
    convertTimestamps: {
      created_at: '%convertTimestamp%',
      updated_at: '%convertTimestamp%',
    },
  },
  sync: {
    debounceTimerMs: 1,
    guard: ['created_by', 'updated_by']
  }
};
export default firestore;